import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgDashboardHouseInventoryFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M7.61 4.71a.76.76 0 01.78 0l4.48 2.82c.24.14.38.4.38.67v5.14c0 .7-.38 1.16-1.16 1.16H3.91c-.62 0-1.16-.46-1.16-1.16V8.2a.8.8 0 01.38-.67zm-1.87 6.6H4.2a.18.18 0 00-.17.17v1.55c0 .1.08.17.17.17h1.54c.1 0 .17-.08.17-.17v-1.55c0-.1-.08-.17-.17-.17zm2.79 0H6.99c-.1 0-.17.08-.17.17v1.55c0 .1.08.17.17.17h1.54c.09 0 .16-.08.16-.17v-1.55c0-.1-.07-.17-.16-.17zm2.74 0H9.73c-.1 0-.17.08-.17.17v1.55c0 .1.08.17.17.17h1.54c.09 0 .16-.08.16-.17v-1.55c0-.1-.07-.17-.16-.17zM5.74 8.48H4.2a.18.18 0 00-.17.17v1.55c0 .1.08.17.17.17h1.54c.1 0 .17-.08.17-.17V8.65c0-.1-.08-.17-.17-.17zm2.79 0H6.99c-.1 0-.17.08-.17.17v1.55c0 .1.08.17.17.17h1.54c.09 0 .16-.08.16-.17V8.65c0-.1-.07-.17-.16-.17zM7.99 1.3h.1c.1.01.22.05.33.11l6.36 3.97a.83.83 0 01-.82 1.45L8 3.09 2.03 6.84a.84.84 0 01-.82-1.45L7.6 1.4c.1-.06.21-.1.34-.1L8 1.29z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgDashboardHouseInventoryFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgDashboardHouseInventoryFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgDashboardHouseInventoryFilled svgRef={ref} {...props} />
));
export default ForwardRef;
